export default __webpack_public_path__ + "static/media/magazine(3).3bbab157.jpg";